/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class ConfigurationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation configurationGet
   */
  static readonly ConfigurationGetPath = '/Configuration';

  /**
   * Retrieving service configuration settings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configurationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  configurationGet$Response(params?: {

    /**
     * Flag indicating whether to hide global settings
     */
    hideGlobal?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ConfigurationService.ConfigurationGetPath, 'get');
    if (params) {
      rb.query('hideGlobal', params.hideGlobal, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Retrieving service configuration settings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configurationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  configurationGet(params?: {

    /**
     * Flag indicating whether to hide global settings
     */
    hideGlobal?: boolean;
  },
  context?: HttpContext

): Observable<void> {

    return this.configurationGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
